/**
 * FormDirtyDock — barra inferior «Tienes cambios sin guardar».
 *
 * Es el dock canónico de las fichas en tarjetas (`.sf2-dock`): aparece pegado
 * abajo dentro del área con scroll cuando hay cambios pendientes y ofrece
 * **Descartar** / **Guardar cambios**. El estándar lo exige en TODAS las
 * fichas; este componente evita que cada ficha copie el mismo bloque (y que
 * unas lo tengan y otras no, que es lo que pasaba).
 *
 * Uso, dentro de `FormCardsShell` (el dock debe quedar dentro del área que
 * hace scroll para que `position: sticky` funcione):
 *
 *   <FormDirtyDock
 *     show={isCards && isDirty}
 *     saving={saving}
 *     onDiscard={handleDiscard}
 *     onSave={() => handleSubmit(null, { force: true })}
 *   />
 */
import React from 'react';

export default function FormDirtyDock({
  show = false,
  saving = false,
  onDiscard,
  onSave,
  text = 'Tienes cambios sin guardar',
  discardLabel = 'Descartar',
  saveLabel = 'Guardar cambios',
  savingLabel = 'Guardando…',
}) {
  if (!show) return null;

  return (
    <div className="sf2-dock">
      <span>{text}</span>
      <span style={{ display: 'flex', gap: 8 }}>
        <button
          className="dv-btn dv-btn-secondary"
          type="button"
          onClick={onDiscard}
          disabled={saving}
        >
          {discardLabel}
        </button>
        <button
          className="dv-btn dv-btn-primary"
          type="button"
          onClick={onSave}
          disabled={saving}
        >
          {saving ? savingLabel : saveLabel}
        </button>
      </span>
    </div>
  );
}
